var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarLabel = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 24,
  fill: "#F1F7FA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.9287 35.25H33.6787C34.5071 35.25 35.1787 34.5784 35.1787 33.75V16.5C35.1787 15.6716 34.5071 15 33.6787 15H14.9287C14.1003 15 13.4287 15.6716 13.4287 16.5V33.75C13.4287 34.5784 14.1003 35.25 14.9287 35.25Z",
  fill: "#E9EEF2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.1787 16.5V19.5H13.4287V16.5C13.4287 16.1022 13.5867 15.7206 13.8681 15.4393C14.1494 15.158 14.5309 15 14.9287 15H33.6787C34.0765 15 34.4581 15.158 34.7394 15.4393C35.0207 15.7206 35.1787 16.1022 35.1787 16.5Z",
  fill: "#C3C6C7"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.4287 22.875H32.9287V24.375H31.4287V22.875Z",
  fill: "#C3C6C7"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9287 30.375H25.4287V31.875H23.9287V30.375Z",
  fill: "#C3C6C7"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9287 30.375H25.4287V31.875H23.9287V30.375Z",
  fill: "#C3C6C7"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1787 22.875H21.6787V24.375H20.1787V22.875Z",
  fill: "#C3C6C7"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M16.4287 26.625H17.9287V28.125H16.4287V26.625Z",
  fill: "#C3C6C7"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1787 26.625H21.6787V28.125H20.1787V26.625Z",
  fill: "#C3C6C7"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M16.4287 30.375H17.9287V31.875H16.4287V30.375Z",
  fill: "#C3C6C7"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1787 30.375H21.6787V31.875H20.1787V30.375Z",
  fill: "#C3C6C7"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0537 14.25C25.0537 13.8358 24.7179 13.5 24.3037 13.5C23.8895 13.5 23.5537 13.8358 23.5537 14.25V16.5C23.5537 16.9142 23.8895 17.25 24.3037 17.25C24.7179 17.25 25.0537 16.9142 25.0537 16.5V14.25Z",
  fill: "#7E8589"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0537 14.25C19.0537 13.8358 18.7179 13.5 18.3037 13.5C17.8895 13.5 17.5537 13.8358 17.5537 14.25V16.5C17.5537 16.9142 17.8895 17.25 18.3037 17.25C18.7179 17.25 19.0537 16.9142 19.0537 16.5V14.25Z",
  fill: "#7E8589"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M31.0537 14.25C31.0537 13.8358 30.7179 13.5 30.3037 13.5C29.8895 13.5 29.5537 13.8358 29.5537 14.25V16.5C29.5537 16.9142 29.8895 17.25 30.3037 17.25C30.7179 17.25 31.0537 16.9142 31.0537 16.5V14.25Z",
  fill: "#7E8589"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M28.4078 28.125L26.5537 27.1001L24.6996 28.125L25.0537 25.9542L23.5537 24.4168L25.6267 24.1001L26.5537 22.125L27.4808 24.1001L29.5537 24.4168L28.0537 25.9542L28.4078 28.125Z",
  fill: "#F7CC38"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M31.4287 26.625H32.9287V28.125H31.4287V26.625Z",
  fill: "#C3C6C7"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M31.4287 30.375H32.9287V31.875H31.4287V30.375Z",
  fill: "#C3C6C7"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M27.6787 30.375H29.1787V31.875H27.6787V30.375Z",
  fill: "#C3C6C7"
})));
export default SvgCalendarLabel;